import { useSelector } from 'react-redux';
import {Navigate, Outlet} from 'react-router-dom'

const PrivateRoute = () => {
    //const { isLoggedIn } = useSelector((state) => state.auth);
   // const user = JSON.parse(localStorage.getItem("user"));
  const { isLoggedIn } = useSelector((state) => state.auth);
    //let auth = {'token':true}
    return(
        isLoggedIn ? <Outlet/> : <Navigate to="/login"/>
    )
}

export default PrivateRoute;